import { IHeSoLopTuNguyenActionTypes } from "../../action-types/thiet-lap/IHeSoLopTuNguyenActionTypes";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IHeSoLopTuNguyenReducer } from "../../reducer-model/thiet-lap/IHeSoLopTuNguyenReducer";
const iniState: IHeSoLopTuNguyenReducer = {
  statusLop: eReducerStatusBase.is_not_initialization,
  statusHeSo: eReducerStatusBase.is_not_initialization,
  heSoLopTuNguyens: [],
  idSelections: [],
  lopTinChis: [],
  request: {
    nam_hoc: "",
    hoc_ky: 0,
    ky_dang_ky: 0,
    id_hes: [],
  },
};
export const heSoLopTuNguyenReducer = (
  state: IHeSoLopTuNguyenReducer = iniState,
  action: IHeSoLopTuNguyenActionTypes
): IHeSoLopTuNguyenReducer => {
  switch (action.type) {
    case "HE_SO_LOP_TU_NGUYEN_LOAD_LOP_START":
      return {
        ...state,
        statusLop: eReducerStatusBase.is_loading,
        idSelections: [],
      };
    case "HE_SO_LOP_TU_NGUYEN_LOAD_LOP_SUCCESS":
      return {
        ...state,
        statusLop: eReducerStatusBase.is_completed,
        lopTinChis: action.payload,
      };
    case "HE_SO_LOP_TU_NGUYEN_LOAD_LOP_ERRR":
      return {
        ...state,
        statusLop: eReducerStatusBase.is_completed,
      };
    case "HE_SO_LOP_TU_NGUYEN_SELECTED_ID":
      return {
        ...state,
        idSelections: action.payload,
      };
    case "HE_SO_LOP_TU_NGUYEN_CHANGE_REQUEST":
      return {
        ...state,
        request: {
          ...state.request,
          ...action.payload,
        },
        statusLop: eReducerStatusBase.is_need_reload,
      };
    case "HE_SO_LOP_TU_NGUYEN_CLOSE_PROCESSING_MODAL":
      return {
        ...state,
        isShowProcessing: false,
      };
    case "HE_SO_LOP_TU_NGUYEN_CHANGE_FOCUSED_CELL":
      return {
        ...state,
        focusedCell: action.payload,
      };

    case "HE_SO_LOP_TU_NGUYEN_LOAD_HESO_START":
      return {
        ...state,
        statusHeSo: eReducerStatusBase.is_loading,
      };
    case "HE_SO_LOP_TU_NGUYEN_LOAD_HESO_SUCCESS":
      return {
        ...state,
        statusHeSo: eReducerStatusBase.is_completed,
        heSoLopTuNguyens: action.payload,
      };
    case "HE_SO_LOP_TU_NGUYEN_LOAD_HESO_ERRR":
      return {
        ...state,
        statusHeSo: eReducerStatusBase.is_completed,
      };
    case "HE_SO_LOP_TU_NGUYEN_SHOW_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: true,
        heSoLopTuNguyenEditing: action.payload,
      };
    case "HE_SO_LOP_TU_NGUYEN_SAVE_HESO_START":
      return {
        ...state,
        statusHeSo: eReducerStatusBase.is_saving,
      };
    case "HE_SO_LOP_TU_NGUYEN_SAVE_HESO_SUCCESS":
      const isExist = state.heSoLopTuNguyens.some(
        (x) => x.id === action.payload.id
      );
      return {
        ...state,
        statusHeSo: eReducerStatusBase.is_saved,
        isShowEditModal: false,
        heSoLopTuNguyens: !isExist
          ? [...state.heSoLopTuNguyens, action.payload]
          : state.heSoLopTuNguyens.map((x) => {
              if (x.id === action.payload.id) {
                return action.payload;
              }
              return x;
            }),
      };
    case "HE_SO_LOP_TU_NGUYEN_SAVE_HESO_ERROR":
      return {
        ...state,
        statusHeSo: eReducerStatusBase.is_saved,
      };
    case "HE_SO_LOP_TU_NGUYEN_CLOSE_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: false,
        heSoLopTuNguyenEditing: undefined,
      };
    case "HE_SO_LOP_TU_NGUYEN_DELETE_HESO_START":
      return {
        ...state,
        statusHeSo: eReducerStatusBase.is_deleting,
      };
    case "HE_SO_LOP_TU_NGUYEN_DELETE_HESO_SUCCESS":
      return {
        ...state,
        statusHeSo: eReducerStatusBase.is_need_reload,
      };
    case "HE_SO_LOP_TU_NGUYEN_DELETE_HESO_ERROR":
      return {
        ...state,
        statusHeSo: eReducerStatusBase.is_completed,
      };
    case "HE_SO_LOP_TU_NGUYEN_SHOW_HESO_MODAL":
      return {
        ...state,
        isShowHeSoModal: true,
        statusHeSo: eReducerStatusBase.is_need_reload,
      };
    case "HE_SO_LOP_TU_NGUYEN_CLOSE_HESO_MODAL":
      return {
        ...state,
        isShowHeSoModal: false,
      };
    case "HE_SO_LOP_TU_NGUYEN_SYNC_START":
      return {
        ...state,
        statusLop: eReducerStatusBase.is_saving,
      };
    case "HE_SO_LOP_TU_NGUYEN_SYNC_SUCCESS":
      return {
        ...state,
        statusLop: eReducerStatusBase.is_saved,
        idSelections: [],
        lopTinChis: state.lopTinChis.map((g) => {
          var updated = action.payload.find((p) => p.id_lop_tc === g.id_lop_tc);
          if (updated) {
            return {
              ...g,
              ...updated,
            };
          }
          return g;
        }),
      };
    case "HE_SO_LOP_TU_NGUYEN_SYNC_ERR":
      return {
        ...state,
        statusLop: eReducerStatusBase.is_saved,
      };
    case "HE_SO_LOP_TU_NGUYEN_SAVE_HESO_LOP_START":
      return {
        ...state,
        statusLop: eReducerStatusBase.is_saving,
      };
    case "HE_SO_LOP_TU_NGUYEN_SAVE_HESO_LOP_SUCCESS":
      return {
        ...state,
        statusLop: eReducerStatusBase.is_saved,
        lopTinChis: state.lopTinChis.map((g) => {
          var check = action.payload.id_lop_tc === g.id_lop_tc;
          if (check) {
            return {
              ...g,
              ...action.payload,
            };
          }
          return g;
        }),
      };
    case "HE_SO_LOP_TU_NGUYEN_SAVE_HESO_LOP_ERR":
      return {
        ...state,
        statusLop: eReducerStatusBase.is_saved,
      };
    default:
      return state;
  }
};
